addEventListener('DOMContentLoaded', () => {
  const wrapper = document.getElementById('cookie_message_wrapper');
  const backdrop = document.getElementById('cookie_backdrop_wrapper');
  const closeButton = document.getElementById('close-cookies');

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      const expires = new Date;
      expires.setTime(expires.getTime() + 31536e6);
      document.cookie = `cookie_banner_closed=true;path=/;expires=${expires.toUTCString()}`

      wrapper.style.display = 'none';
      backdrop.style.display = 'none';
    });
  }
});
